import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperSide: {
    gap: "32px",
  },
  fieldWrapper: {
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
    },
  },
}));
